/* eslint-disable @typescript-eslint/no-this-alias */ /* eslint-disable
vue/no-parsing-error */ /* eslint-disable vue/no-parsing-error */ /*
eslint-disable @typescript-eslint/explicit-module-boundary-types */
<template>
  <div style="height:643px">
    <div :style="image">
      <span class="title2">
        服务门店查询
      </span>
    </div>
  </div>

  <div class="total">
    <div class="pad">
      <div style="display: flex; margin-top:50px; justify-content:center">
        <div style="display:flex; justify-content:space-around; width:1200px">
          <span class="title" style="white-space:nowrap">搜索门店地址</span>

          <div class="input-item" style="">
            <el-select
              v-model="provinceValue"
              @change="provinceChange"
              placeholder="请选择省"
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="input-item" style="">
            <el-select
              v-model="cityValue"
              placeholder="请选择市"
              @change="cityChange"
            >
              <el-option
                v-for="item in cityOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="input-item" style="">
            <el-select
              v-model="countryValue"
              placeholder="请选择区"
              @change="countryChange"
            >
              <el-option
                v-for="item in countryOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="input-item" style="">
            <el-select v-model="brandValue" placeholder="请选择型号">
              <el-option
                v-for="item in brandOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="all">
        <div id="container" class="map"></div>
        <div class="shop" id="all">
          <div style="margin-top:0px; padding-top:30px">
            <template v-for="(item, index) in shopList" :key="index">
              <div
                :id="'title' + (index + 1)"
                style=" height:267px; padding-top:30px"
                @click="
                  changeStyle(index + 1, item.detail, item.mobile, item.busTime)
                "
              >
                <div style="display:flex; margin-left:25px">
                  <div>
                    <img src="../assets/images/marker.svg" style="width:25px" />
                  </div>

                  <div
                    style="margin-left:17px; max-width:316px; text-align:left;"
                  >
                    <!-- <span class="content">U-MAGIC授权服务中心（朝阳门）</span> -->
                    <span class="content">{{ item.name }}</span>
                  </div>
                </div>

                <div class="box">
                  <img src="../assets/images/location1.svg" />
                  <div
                    style="margin-left:20px;text-align:left; margin-right:20px"
                  >
                    <span class="content" style="color:#535353 ">{{
                      item.detail
                    }}</span>
                  </div>
                </div>

                <div class="box">
                  <img src="../assets/images/fa-phone1.svg" />
                  <div
                    style="margin-left:28px;text-align:left; margin-right:20px"
                  >
                    <span class="content" style="color:#535353">{{
                      item.mobile
                    }}</span>
                  </div>
                </div>

                <div class="box">
                  <img src="../assets/images/time1.svg" />
                  <div
                    style="margin-left:23px; text-align:left; margin-right:20px"
                  >
                    <span class="content" style="color:#535353"
                      >营业时间：{{ item.busTime }}</span
                    >
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 
  <div class="dialog">
    <el-dialog
      title="温馨提示"
      :model-value="dialogVisible"
      width="50%"
      :before-close="handleClose"
      style="text-align:left"
    >
      <p class="p">
        尊敬的用户，您好，春节期间部分NZONE授权客户服务中心暂停营业，预计2月7日恢复正常，给您带来不便，请您谅解。在此期间，请您拨打400-699-6999官方客服热线，咨询门店实际营业情况。
      </p>
      <p class="p">
        在此，温馨提醒您做好安全防护工作，保护自己及家人的身体健康。祝您阖家欢乐，幸福安康，虎年大吉！
      </p>
      <template v-slot:footer>
        <span class="dialog-footer">
          <button class="button" @click="dialogVisible = false">确 定</button>
        </span>
      </template>
    </el-dialog>
  </div> -->
</template>

<script>
import area from "../js/area.js";
import * as api from "../api/apt";

export default {
  components: {},
  filters: {},
  mixins: [],
  props: {
    provinceProp: {
      type: String,
      default: ""
    },
    cityProp: {
      type: String,
      default: ""
    },
    countryProp: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      image: {
        height: "643px",
        position: "relative",
        backgroundImage:
          "linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.5)),url(" +
          require("../assets/images/shop.png") +
          ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPositionY: "30%"
      },
      useDiv: 0,
      dialogVisible: false,

      shopList: [],
      idList: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      map: null,
      myGeo: null,
      provinceValue: "",
      cityValue: "",
      countryValue: "",
      provinceOptions: [],
      cityOptions: [],
      countryOptions: [],
      areaData: null,
      pointList: [],
      brandOptions: [
        { value: "NZONE S7 pro", label: "NZONE S7 pro" },
        { value: "NZONE S7 pro+", label: "NZONE S7 pro+" },
        { value: "NZONE S7", label: "NZONE S7" }
      ],
      brandValue: ""
    };
  },
  methods: {
    getShopMessage(country, district, province) {
      api.getShopMessage(country, district, "", province).then(res => {
        let index = 1;
        if (this.shopList.length > 0) {
          this.shopList = [];
        }

        // console.log(res.data.result.results)
        for (let o of res.data.result.results) {
          this.shopList.push(o);
          // this.baiduMap()
          // console.log(o)
          // console.log(o.longitude)
          this.addPoint(
            o.longitude,
            o.latitude,
            index,
            o.detail,
            o.mobile,
            o.busTime
          );
          index++;
        }
        // console.log(this.shopList)
        this.useDiv = 0;
      });
    },

    addPoint(a, b, id, details, phone, time) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      let that = this;

      var point = new BMapGL.Point(a, b);
      var marker = new BMapGL.Marker(point, { width: 50 });
      this.map.addOverlay(marker);

      if (id >= 10) {
        var label = new BMapGL.Label(id, {
          //调整数字跟点标记的位置关系
          offset: new BMapGL.Size(-8, -20)
        });
      } else {
        var label = new BMapGL.Label(id, {
          //调整数字跟点标记的位置关系
          offset: new BMapGL.Size(-5, -20)
        });
      }

      label.setStyle({
        background: "none",
        color: "#fff",
        border: "none"
      });
      //对label的样式进行设置
      marker.setLabel(label);
      var opts = {
        width: 400,
        height: 100,
        title: "NZONE授权客户服务中心"
      };
      // console.log(details)
      var infoWindow = new BMapGL.InfoWindow(
        details + "<br/>" + phone + "<br/>" + time,
        opts
      );

      marker.addEventListener("click", function() {
        that.map.openInfoWindow(infoWindow, point);
        let all = document.getElementById("all");
        if (that.useDiv != 0) {
          // console.log(that.useDiv)
          let element = document.getElementById("title" + that.useDiv);
          element.style.background = "#F7F7F7 100%";
        }
        that.useDiv = id;
        let title = document.getElementById("title" + id);
        title.style.background = "#E0E0E0 100%";
        // all.scrollTo(0, 287)
        // all.scrollTo(0, 554)
        if (id > 2) {
          all.scrollTo(0, 267 * (id - 2));
        } else {
          all.scrollTo(0, 0);
        }
      });

      that.pointList.push(point);
    },

    changeCity(cityName) {
      this.map.centerAndZoom(cityName, 10);
    },

    baiduMap() {
      this.map = new BMapGL.Map("container");
      this.myGeo = new BMapGL.Geocoder();

      var cityName = "北京市";
      this.map.centerAndZoom(cityName, 10); // 初始化地图,设置中心点坐标和地图级别。    map.addControl(new BMap.ScaleControl());                    // 添加比例尺控件
      this.map.enableScrollWheelZoom();
    },

    changeStyle(id, details, phone, time) {
      if (this.useDiv != 0) {
        // console.log(this.useDiv)
        let element = document.getElementById("title" + this.useDiv);
        element.style.background = "#F7F7F7 100%";
      }

      let element = document.getElementById("title" + id);
      element.style.background = "#E0E0E0 100%";
      this.useDiv = id;

      let point = this.pointList[id - 1];
      var opts = {
        width: 400,
        height: 100,
        title: "NZONE授权客户服务中心"
      };
      var infoWindow = new BMapGL.InfoWindow(
        details + "<br/>" + phone + "<br/>" + time,
        opts
      );
      this.map.openInfoWindow(infoWindow, point);
    },

    init() {
      if (this.provinceProp) {
        this.provinceValue = this.provinceProp;
        this.provinceChange();
      }
      if (this.cityProp) {
        this.cityValue = this.cityProp;
        this.cityChange();
      }
      if (this.countryProp) {
        this.countryValue = this.countryProp;
        this.countryChange();
      }
    },
    handleArea() {
      this.provinceOptions = [];
      this.provinceValue = "";
      for (const key in area["86"]) {
        this.provinceOptions.push({
          value: key,
          label: area["86"][key]
        });
      }
    },
    resetCityAndCountryData() {
      this.cityValue = "";
      this.countryValue = "";
      this.cityOptions = [];
      this.countryOptions = [];
      this.shopList = [];
    },
    resetCountryData() {
      this.countryValue = "";
      this.countryOptions = [];
      this.shopList = [];
    },
    provinceChange() {
      this.resetCityAndCountryData();
      for (const key in area[this.provinceValue]) {
        this.cityOptions.push({
          value: key,
          label: area[this.provinceValue][key]
        });
      }
      this.chooseData();
      // console.log(area[86][this.provinceValue])
      this.map.centerAndZoom(area[86][this.provinceValue], 5);
      let overlays = this.map.getOverlays();
      for (let i = 0; i < overlays.length; i++) {
        this.map.removeOverlay(overlays[i]);
      }

      if (this.useDiv != 0) {
        let element = document.getElementById("title" + this.useDiv);
        // console.log(element)
        if (element != null) {
          element.style.background = "#F7F7F7 10000%";
        }
      }

      this.pointList = [];

      this.getShopMessage("", "", area[86][this.provinceValue]);
    },
    cityChange() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      var that = this;
      this.resetCountryData();
      for (const key in area[this.cityValue]) {
        this.countryOptions.push({
          value: key,
          label: area[this.cityValue][key]
        });
      }
      this.chooseData();
      // console.log(this.cityValue)
      //  console.log(area[this.provinceValue][this.cityValue])

      //  if(area[86][this.provinceValue] == '台湾省'){
      //    this.map.centerAndZoom(area[this.provinceValue][this.cityValue], 12)
      //  }else{
      //    this.map.centerAndZoom(area[86][this.provinceValue] + area[this.provinceValue][this.cityValue],12)

      //  }

      this.myGeo.getPoint(
        area[this.provinceValue][this.cityValue],
        function(point) {
          if (point) {
            that.map.centerAndZoom(point, 10);
          } else {
            alert("您选择的地址没有解析到结果！");
          }
        },
        area[this.provinceValue][this.cityValue]
      );

      let overlays = this.map.getOverlays();
      for (let i = 0; i < overlays.length; i++) {
        this.map.removeOverlay(overlays[i]);
      }

      if (this.useDiv != 0) {
        let element = document.getElementById("title" + this.useDiv);
        // console.log(element)
        if (element != null) {
          element.style.background = "#F7F7F7 10000%";
        }
      }

      this.pointList = [];

      this.getShopMessage(
        "",
        area[this.provinceValue][this.cityValue],
        area[86][this.provinceValue]
      );
    },
    countryChange() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      let that = this;
      this.chooseData();
      // console.log(area[this.provinceValue][this.cityValue])
      // console.log(area[this.cityValue][this.countryValue])
      // if(area[this.cityValue][this.countryValue] == '无为市'){
      //   this.map.centerAndZoom('无为县',15)
      // }
      // }else if(area[this.cityValue][this.countryValue] == '蓬莱区'){
      //   this.map.centerAndZoom('蓬莱市',15)
      // }
      // else if(area[this.cityValue][this.countryValue].indexOf('镇') > 0 || area[this.cityValue][this.countryValue].indexOf('街道') > 0 ||  area[this.cityValue][this.countryValue].indexOf('农场') > 0 ||  area[this.cityValue][this.countryValue].indexOf('乡') > 0){

      // }

      this.myGeo.getPoint(
        area[this.cityValue][this.countryValue],
        function(point) {
          if (point) {
            that.map.centerAndZoom(point, 15);
          } else {
            alert("您选择的地址没有解析到结果！");
          }
        },
        area[this.provinceValue][this.cityValue]
      );

      let overlays = this.map.getOverlays();
      for (let i = 0; i < overlays.length; i++) {
        this.map.removeOverlay(overlays[i]);
      }

      if (this.useDiv != 0) {
        let element = document.getElementById("title" + this.useDiv);
        // console.log(element)
        if (element != null) {
          element.style.background = "#F7F7F7 10000%";
        }
      }

      this.pointList = [];

      this.getShopMessage(
        area[this.cityValue][this.countryValue],
        area[this.provinceValue][this.cityValue],
        area[86][this.provinceValue]
      );
    },
    chooseData() {
      // console.log(this.provinceValue, this.cityValue, this.countryValue)
      // console.log(area['86'][this.provinceValue], area[this.provinceValue][this.cityValue], area[this.cityValue][this.countryValue])
      let data = null;
      if (this.countryValue) {
        data = {
          province: {
            code: this.provinceValue,
            name: area["86"][this.provinceValue]
          },
          city: {
            code: this.cityValue,
            name: area[this.provinceValue][this.cityValue]
          },
          country: {
            code: this.countryValue,
            name: area[this.cityValue][this.countryValue]
          }
        };
      } else if (this.cityValue) {
        data = {
          province: {
            code: this.provinceValue,
            name: area["86"][this.provinceValue]
          },
          city: {
            code: this.cityValue,
            name: area[this.provinceValue][this.cityValue]
          }
        };
      } else if (this.provinceValue) {
        data = {
          province: {
            code: this.provinceValue,
            name: area["86"][this.provinceValue]
          }
        };
      } else {
        data = null;
      }
      this.areaData = data;
    }
  },

  mounted() {
    this.baiduMap();
    this.handleArea();
    this.init();
    this.getShopMessage("", "", "北京市");
  }
};
</script>

<style scoped>
.title {
  font-size: 28px;
  font-style: SourceHanSansSC-bold;

  color: black;
  text-decoration: none;
}

.content {
  font-size: 16px;
  font-style: SourceHanSansSC-regular;
  word-break: break-all;
}

.amap-copyright {
  box-sizing: content-box;
}
* {
  box-sizing: border-box;
}
.input-textarea {
  color: grey;
  height: 8em;
  overflow: auto;
  border-radius: 0.4rem;
  border: 1px solid #ced4da;
  margin-bottom: 1rem;
}
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol", "Noto Color Emoji";
  line-height: 1.5;
  font-weight: 300;
  color: #111213;
}

hr {
  margin: 0.5rem 0;
  box-sizing: content-box;
  height: 0;
  overflow: visible;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

p {
  margin-top: 0;
  margin-bottom: 0;
}

label {
  display: inline-block;
  margin-bottom: 0.4rem;
}

label,
.btn {
  margin-left: 0;
  font-size: 1rem;
}

button,
input,
select {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  overflow: visible;
  text-transform: none;
}

[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner,
button::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  margin: 0 0.5rem 0 0;
}

h4 {
  font-family: inherit;
  line-height: 1.8;
  font-weight: 300;
  color: inherit;
  font-size: 1.1rem;
  margin-top: 0;
  margin-bottom: 0.5rem;
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background-color: transparent;
  background-image: none;
  color: #25a5f7;
  border-color: #25a5f7;
  padding: 0.25rem 0.5rem;
  line-height: 1.5;
  border-radius: 1rem;
  -webkit-appearance: button;
  cursor: pointer;
}

.btn:hover {
  color: #fff;
  background-color: #25a5f7;
  border-color: #25a5f7;
}

.btn:hover {
  text-decoration: none;
}

.input-item {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: center;
  align-items: center;
  width: 200px;
  height: 3rem;
}

.input-item:last-child {
  margin-bottom: 0;
}

.input-item > select,
.input-item > input[type="text"],
.input-item > input[type="date"] {
  position: relative;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}

.input-item > select:not(:last-child),
.input-item > input[type="text"]:not(:last-child),
.input-item > input[type="date"]:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-item > select:not(:first-child),
.input-item > input[type="text"]:not(:first-child),
.input-item > input[type="date"]:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-item-prepend {
  margin-right: -1px;
}

.input-item-text,
input[type="text"],
input[type="date"],
select {
  height: calc(2.2rem + 2px);
}

.input-item-text {
  width: 6rem;
  text-align: justify;
  padding: 0.4rem 0.7rem;
  display: inline-block;
  text-justify: distribute-all-lines;
  /*ie6-8*/
  text-align-last: justify;
  /* ie9*/
  -moz-text-align-last: justify;
  /*ff*/
  -webkit-text-align-last: justify;
  /*chrome 20+*/
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.input-item-text input[type="checkbox"],
.input-item-text input[type="radio"] {
  margin-top: 0;
}

.input-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-radius: 0.25rem;
  width: 22rem;
  border-width: 0;
  border-radius: 0.4rem;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 0.75rem 1.25rem;
}

.input-text {
  line-height: 2rem;
  margin-right: 2rem;
}

.info hr {
  margin-right: 0;
  margin-left: 0;
  border-top-color: grey;
}

.info {
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border-radius: 0.25rem;
  position: fixed;
  top: 1rem;
  background-color: white;
  width: auto;
  min-width: 22rem;
  border-width: 0;
  right: 1rem;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
}

.code {
  left: 1.5rem;
  right: 1.5rem;
  top: 1.5rem;
  bottom: 1.5rem;
  overflow: auto;
  margin-bottom: 0rem;
}

.code .btn {
  top: 1rem;
  position: absolute;
  right: 1rem;
}

.code .result {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  padding: 1rem;
  bottom: 1rem;
  position: absolute;
  top: 5.5rem;
  right: 1rem;
  left: 1rem;
  overflow: auto;
}

.code .status {
  color: #80adff;
  display: inline-block;
  font-size: 14px;
}

.code h4 {
  display: inline-block;
  max-width: 20rem;
  margin-right: 1rem;
  margin-bottom: 1rem;
}

select,
input[type="text"],
input[type="date"] {
  display: inline-block;
  width: 100%;
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff
    url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
    no-repeat right 0.75rem center;
  background-size: 8px 10px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

input[type="text"],
input[type="date"] {
  background: #fff;
  padding: 0.375rem 0.75rem;
}

select:focus,
input[type="text"]:focus,
input[type="date"]:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.1rem rgba(128, 189, 255, 0.1);
}

.btn:focus {
  outline: 0;
  box-shadow: none;
}

:deep() .el-select {
  width: 13vw;
}

select:focus::-ms-value,
input[type="text"]:focus::-ms-value,
input[type="date"]:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}

/* native toastr */
.native-toast {
  position: fixed;
  background-color: rgba(50, 50, 50, 0.8);
  border-radius: 33px;
  color: white;
  left: 50%;
  text-align: center;
  padding: 6px 12px;
  opacity: 0;
  z-index: 99999;
  transition: transform 0.25s, opacity 0.25s, top 0.25s;
  box-sizing: border-box;
}

.native-toast-bottom {
  bottom: 50px;
  -ms-transform: translateX(-50%) translateY(50px);
  transform: translateX(-50%) translateY(50px);
}

.native-toast-bottom.native-toast-shown {
  opacity: 1;
  -ms-transform: translateX(-50%) translateY(0);
  transform: translateX(-50%) translateY(0);
}

.native-toast-bottom.native-toast-edge {
  bottom: 0;
}

.native-toast-top {
  top: 50px;
  -ms-transform: translateX(-50%) translateY(-50px);
  transform: translateX(-50%) translateY(-50px);
}

.native-toast-top.native-toast-shown {
  opacity: 1;
  -ms-transform: translateX(-50%) translateY(0);
  transform: translateX(-50%) translateY(0);
}

.native-toast-top.native-toast-edge {
  top: 0;
}

.native-toast-center {
  top: 0;
  -ms-transform: translateX(-50%) translateY(-50px);
  transform: translateX(-50%) translateY(-50px);
}

.native-toast-center.native-toast-shown {
  opacity: 1;
  top: 50%;
  -ms-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}

.native-toast-edge {
  border-radius: 0;
  width: 100%;
  text-align: left;
}

.pad {
  padding-top: 50px;
  margin: auto 0;
  width: 1200px;
}

@media screen and (min-width: 40rem) {
  .native-toast:not(.native-toast-edge) {
    max-width: 18rem;
  }
}

/*
  max-width does not seem to work in small screen?
*/

/*@media screen and (max-width: 768px) {
  .native-toast:not(.native-toast-edge) {
    max-width: 400px;
  }
}

@media screen and (max-width: 468px) {
  .native-toast:not(.native-toast-edge) {
    max-width: 300px;
  }
}*/

/* types */

.native-toast-error {
  background-color: #d92727;
  color: white;
}

.native-toast-success {
  background-color: #62a465;
  color: white;
}

.native-toast-warning {
  background-color: #fdaf17;
  color: white;
}

.native-toast-info {
  background-color: #5060ba;
  color: white;
}

[class^="native-toast-icon-"] {
  vertical-align: middle;
  margin-right: 8px;
}

[class^="native-toast-icon-"] svg {
  width: 16px;
  height: 16px;
}

.all {
  display: flex;
  margin-top: 50px;
  height: 800px;
}

.shop {
  width: 450px;
  background-color: rgb(247, 247, 247);
  margin-left: 50px;
  overflow: auto;
  overflow-x: hidden;
}

.id {
  width: 20px;
  height: 20px;
  background-color: #9b001b;
  border-radius: 50%;
  color: white;
  margin-top: 3px;
}

.box {
  display: flex;
  margin-left: 30px;
  margin-top: 20px;
}

.map {
  height: 800px;
  width: 800px;
}

.imgbox {
  height: 643px;
}

.image {
  height: 643px;
  position: relative;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../assets/images/shop.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: 65%;
}

.title2 {
  font-size: 48px;
  font-style: SourceHanSansSC-bold;
  color: black;
  text-decoration: none;
  position: absolute;
  top: 45%;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  color: white;
  font-weight: bold;
}

.total {
  display: flex;
  justify-content: center;
  margin-bottom: 100px;
}

.p {
  font-size: 16px;
  color: #333333;
  line-height: 34px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
}

.button {
  width: 160px;
  height: 38px;
  cursor: pointer;
  background-color: #333333;
  color: white;
  border-radius: 4px;
  border: none;
}

.button:hover {
  width: 160px;
  height: 38px;
  cursor: pointer;
  background-color: #3b6caa;
  color: white;
  border-radius: 4px;
  border: none;
}
</style>

<style scoped>
.dialog >>> .el-dialog__body {
  text-align: left !important;
}
.dialog >>> .el-dialog__title {
  font-size: 22px !important;
  font-weight: bold;
}

.dialog >>> .el-dialog__footer {
  text-align: center;
}
</style>
